import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"15px"} }, "服务有效期", -1)
const _hoisted_2 = { style: {"width":"100%"} }

import { ref, watch } from 'vue';
import {
  BaseTextContent,
  BaseTextTitle,
  useCreateModal,
  BaseButton,
  BaseForm,
  BaseFormItem,
  BaseCheckbox
} from 'xrk-components';
import DetailAddTimeDialog from './add-time-dialog.vue';
import { IndividualInfoDetailData } from '../../data-source/types';
import { formatter } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'validity',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: /*#__PURE__*/_mergeModels(['success'], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {

const emits = __emit;

const ruleFormRef = ref();
const formData = _useModel<IndividualInfoDetailData>(__props, "modelValue");
const historyDates = ref([]);

watch(
  () => formData.value,
  v => {
    if (v.historyExpiraDateList.length) {
      historyDates.value = v.historyExpiraDateList.reduce((pre, cur) => {
        pre.push([cur.startAt, cur.endAt]);
        return pre;
      }, []);
    }
  },
  {
    immediate: true,
    deep: true
  }
);

const formatDates = dates => {
  if (!dates.length) return '';
  return dates
    .map(item => {
      return formatter.date(item, 'YYYY-MM-DD');
    })
    .join(' ~ ');
};
const onAdd = () => {
  useCreateModal(DetailAddTimeDialog, {
    id: formData.value.id,
    expiraEnd: formData.value.expiraEnd,
    registerAt: formData.value.registerAt,
    historyExpiraDateList: formData.value.historyExpiraDateList,
    onSuccess: () => {
      emits('success');
    }
  });
};
const onChangePermanent = val => {
  if (val) {
    formData.value._expira = [];
  }
};

__expose({
  validate: () => {
    return ruleFormRef.value.validate();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BaseTextTitle), null, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_unref(BaseButton), {
          onClick: onAdd,
          disabled: !!formData.value.isPermanent
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 新增延期 ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        (formData.value.isPermanent)
          ? (_openBlock(), _createBlock(_unref(BaseCheckbox), {
              key: 0,
              disabled: "",
              "true-value": 1,
              "false-value": 0,
              modelValue: formData.value.isPermanent,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.isPermanent) = $event)),
              onChange: onChangePermanent
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 长期有效 ")
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_unref(BaseTextContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseForm), {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: formData.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              label: "服务有效期",
              prop: "_expira",
              rules: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
            validator(_rule, value, callback) {
              if (!value.length && !formData.value.isPermanent) {
                callback(new Error('请选择'));
              } else {
                callback();
              }
            }
          }
        ]
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(formatDates(formData.value._expira)), 1)
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_unref(BaseFormItem), {
              label: "延期日期",
              prop: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyDates.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      style: {"width":"100%"}
                    }, _toDisplayString(formatDates(historyDates.value[index])), 1))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ], 64))
}
}

})